module.exports = __webpack_public_path__ + "img/bosch.70121fd1.png";